<template lang="pug">
  include UserPanel.pug
</template>

<script type="text/javascript">
import api from "@/service/api"
import { mapState } from "vuex";

export default {
  name: "UserPanel",
  computed: mapState([
    "token",
    "username"
  ]),
  data() {
    return {
      alias: "",
      dni: "",
      email: "",
      first_name: "",
      last_name: "",
    }
  },
  async created() {
    const responseMe = await api.me(this.token)
    const data = responseMe.data
    this.alias = data.alias
    this.email = data.email
    this.dni = data.dni
    this.first_name = data.first_name
    this.last_name = data.last_name
  },
  methods: {
    async save() {
      const response = await api.updateCustomer(this.token, this.first_name, this.last_name, this.dni, this.alias)
      const data = response.data
      alert("Datos guardados correctamente")
    }
  }
}
</script>
